(() => {
  const forms = document.querySelectorAll('form.basic-validation');
  const isEmptyRequiredField = (field, form) => {
    if (!field.required || field.disabled) return false;

    if (field.type === 'radio') {
      if (!field.name) return !field.checked;
      return !form.querySelector(
        `input[type="radio"][name="${CSS.escape(field.name)}"]:checked`,
      );
    }

    if (field.type === 'checkbox') {
      return !field.checked;
    }

    return !field.value.trim();
  };

  const updateFieldState = (field, form) => {
    form.querySelector('.be-validation-error')?.remove();
    if (!field.hasAttribute('placeholder')) return;
    field.classList.toggle(
      'required-placeholder-red',
      isEmptyRequiredField(field, form),
    );
  };

  forms.forEach((form) => {
    const requiredFields = Array.from(form.querySelectorAll('[required]'));

    form.addEventListener('submit', (event) => {
      let hasErrors = false;

      requiredFields.forEach((field) => {
        const isEmpty = isEmptyRequiredField(field, form);
        if (field.hasAttribute('placeholder')) {
          field.classList.toggle('required-placeholder-red', isEmpty);
        }
        if (isEmpty) hasErrors = true;
      });

      if (hasErrors) {
        event.preventDefault();
      }
    });

    requiredFields.forEach((field) => {
      const eventName =
        field.type === 'checkbox' || field.type === 'radio'
          ? 'change'
          : 'input';
      field.addEventListener(eventName, () => updateFieldState(field, form));
    });
  });
})();
